/*
 * Application Insights JavaScript SDK - Properties Plugin, 2.6.2
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Application = /** @class */ (function () {
    function Application() {
    }
    return Application;
}());
export { Application };
//# sourceMappingURL=Application.js.map